// import React, { useState } from "react";
// import * as emailjs from "emailjs-com";
// import "./style.css";
// import { Helmet, HelmetProvider } from "react-helmet-async";
// import { meta } from "../../content_option";
// import { Container, Row, Col, Alert } from "react-bootstrap";
// import { contactConfig } from "../../content_option";
// import { TfiEmail } from "react-icons/tfi";
// import { SlPhone } from "react-icons/sl";
// import { useFormik } from "formik";
// import { contactUsSchema } from "./schema";
// import bgGiff from "../../assets/videos/about.mp4";
// import fadeURl from "../../assets/videos/JPS-138.jpg"
// import Footer from "../../components/footer";
// import { useRef } from "react";

// export const ContactUs = () => {
//   const [formData, setFormdata] = useState({
//     loading: false,
//     show: false,
//     alertmessage: "",
//     variant: "",
//   });

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     setFormdata({ loading: true });

//     const templateParams = {
//       from_name: formData.email,
//       user_name: formData.yourname,
//       to_name: contactConfig.YOUR_EMAIL,
//       message: formData.message,
//     };

//     emailjs
//       .send(
//         contactConfig.YOUR_SERVICE_ID,
//         contactConfig.YOUR_TEMPLATE_ID,
//         templateParams,
//         contactConfig.YOUR_USER_ID
//       )
//       .then(
//         (result) => {
//           console.log(result.text);
//           setFormdata({
//             loading: false,
//             alertmessage: "SUCCESS! Thank you for your message",
//             variant: "success",
//             show: true,
//           });
//         },
//         (error) => {
//           console.log(error.text);
//           setFormdata({
//             alertmessage: `Failed to send! ${error.text}`,
//             variant: "danger",
//             show: true,
//           });
//           document.getElementsByClassName("co_alert")[0].scrollIntoView();
//         }
//       );
//   };

//   const { handleChange, handleBlur, errors, touched } = useFormik({
//     initialValues: {
//       name: "",
//       weddingDate: "",
//       vanue: "",
//       planners: "",
//       photographer: "",
//       instagram: "",
//       sthAboutUs: "",
//     },
//     validationSchema: contactUsSchema,
//     onSubmit: async (values) => { },
//   });

//   const dateInputRef = useRef(null);

//   const handleFocus = () => {
//     dateInputRef.current?.showPicker(); // For browsers that support it
//   };
//   return (
//     <HelmetProvider>
//       <Helmet>
//         <meta charSet="utf-8" />
//         <title>{meta.title} | Contact</title>
//         <meta name="description" content={meta.description} />
//       </Helmet>
//       <div style={{ position: "relative" }}>
//         {/* <video
//           src={bgGiff}
//           autoPlay
//           loop
//           muted
//           className="vid"
//           style={{
//             height: "38vh",
//             width: "100%",
//             position: "absolute",
//             objectFit: "cover",
//             zIndex: "-1",
//             top: 0,
//           }}
//         ></video> */}
//         <img
//           src={fadeURl} // Use your image source
//           alt="Overlay image"
//           style={{
//             height: "100%",
//             width: "100%",
//             zIndex: "-1",
//             top: 0,
//           }}
//         />
//         <div className="contact-video-overlay">
//           <div
//             className="container"
//             style={{ textTransform: "uppercase", textAlign: "left" }}
//           >
//             <h3 className="contactHeading" style={{}}>
//               HAVE WE MET BEFORE?
//             </h3>
//             <p className="contactSubHeading" style={{}}>
//               BECAUSE YOU LOOK EXACTLY LIKE OUR NEXT COUPLE
//             </p>
//           </div>
//         </div>
//         {/* <div style={{ position: "relative" }}>
//           <img
//             src={fadeURl} // Use your image source
//             alt="Overlay image"
//             style={{
//               position: "relative",
//               top: "250px",
//               bottom: "0",
//               left: "50%",
//               transform: "translateX(-50%)",
//               zIndex: "-1",
//               width: "100%",
//               Height: "50vh",
//               objectFit: "cover",
//             }}
//           />
//         </div> */}
//       </div>

//       <div className="About-header">
//         <Row className="sec_sp d-flex justify-content-center  mt-5 pt-5">
//           <Col lg="12">
//             <Alert
//               variant={formData.variant}
//               className={`rounded-0 co_alert ${formData.show ? "d-block" : "d-none"
//                 }`}
//               onClose={() => setFormdata({ show: false })}
//               dismissible
//             >
//               <p className="my-0">{formData.alertmessage}</p>
//             </Alert>
//           </Col>

//           <div lg="9" className="contactFarm d-flex align-items-center">
//             <form onSubmit={handleSubmit} className="contact__form w-100">
//               <Row className="d-flex contact-inner">
//                 <Col lg="12" className="form-group">
//                   <label>My Fiance & I</label>
//                   <input
//                     className="form-control rounded-0"
//                     id="name"
//                     name="name"
//                     placeholder="Audrey Hepburn & Frank Sinata"
//                     type="text"
//                     onBlur={handleBlur}
//                     onChange={handleChange}
//                   />
//                 </Col>

//                 <Col lg="12" className="form-group">
//                   <label>Are getting married on the</label>
//                   <input
//                     required
//                     className="form-control rounded-0"
//                     name="weddingDate"
//                     type="date"
//                     ref={dateInputRef}
//                     onFocus={handleFocus}
//                     onChange={handleChange}
//                     onBlur={handleBlur}
//                   />
//                 </Col>
//                 <Col lg="12" className="form-group">
//                   <label>At</label>
//                   <input
//                     required
//                     className="form-control rounded-0"
//                     id="vanue"
//                     name="vanue"
//                     placeholder="Qubec City, CA"
//                     type="text"
//                     onBlur={handleBlur}
//                     onChange={handleChange}
//                   />
//                 </Col>
//                 <Col lg="12" className="form-group">
//                   <label>Planned By</label>
//                   <input
//                     required
//                     className="form-control rounded-0"
//                     id="planners"
//                     name="palnners"
//                     placeholder="Wedding is planned by XYZ"
//                     type="text"
//                     onBlur={handleBlur}
//                     onChange={handleChange}
//                   />
//                 </Col>
//                 <Col lg="12" className="form-group">
//                   <label>And my Instagram handle is</label>
//                   <input
//                     required
//                     className="form-control rounded-0"
//                     id="instagram"
//                     name="instagram"
//                     placeholder="@audreharbper"
//                     type="text"
//                     onBlur={handleBlur}
//                     onChange={handleChange}
//                   />
//                 </Col>
//                 <Col lg="12" className="form-group">
//                   <label>Here is little bit about our plans</label>
//                   <textarea
//                     required
//                     className="form-control rounded-0"
//                     id="sthAboutUs"
//                     name="sthAboutUs "
//                     type="text"
//                     onBlur={handleBlur}
//                     onChange={handleChange}
//                   />
//                 </Col>
//                 <Col lg="12" className="form-group">
//                   <button className="submitButton" type="submit">
//                     {formData.loading ? "Sending..." : "Send"}
//                   </button>
//                 </Col>
//               </Row>
//             </form>
//           </div>
//         </Row>
//       </div>

//       <div className="hello mt-5 mb-5 ">
//         <h2 className="HelloHeading">Want to say hello?</h2>
//         <p className="HelloDesc"> Send us an email: <a href="mailto:Hello@madeinheaven.ca">Hello@madeinheaven.ca</a> </p>
//       </div>
//       <Footer />
//       <div className={formData.loading ? "loading-bar" : "d-none"}></div>
//     </HelmetProvider>
//   );
// };

import React, { useState, useEffect } from "react";
import * as emailjs from "emailjs-com";
import "./style.css";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { meta } from "../../content_option";
import { Container, Row, Col, Alert } from "react-bootstrap";
import { contactConfig } from "../../content_option";
import { TfiEmail } from "react-icons/tfi";
import { SlPhone } from "react-icons/sl";
import { Form, useFormik } from "formik";
import { contactUsSchema } from "./schema";
import footvideo from "../../assets/videos/movingartfootervideo.mp4";
import fadeURl from "../../assets/videos/MIHGetInTouch.webp";
import Footer from "../../components/footer";
import { useRef } from "react";
import debounce from "lodash.debounce";
// import contactVideo from "../../assets/videos/about.mp4";
import contactVideo from "../../assets/videos/Gif-get-in-touch.mp4";
import { send } from 'emailjs-com';

export const ContactUs = () => {
  const [formData, setFormdata] = useState({
    loading: false,
    show: false,
    alertmessage: "",
    variant: "",
  });
  const [scrollY, setScrollY] = useState(0);
  const scrollRef = useRef(0);

  useEffect(() => {
    const handleScroll = debounce(() => {
      // Directly update the scroll position on scroll event
      scrollRef.current = window.scrollY;
      setScrollY(scrollRef.current);
    }); // Reduce the debounce delay for more immediate response

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  const imageOpacity = Math.max(0, 2.4 - scrollY / 450);

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validatePhone = (phone) => {
  const cleanedPhone = phone.replace(/[\s\-\(\)]/g, '');
  const phoneRegex = /^\d{10,12}$/;
  return phoneRegex.test(cleanedPhone);
};

  const handleSubmit = (e) => {
    e.preventDefault();
    setFormdata({ loading: true });

  //   const templateParams = {
  //     from_name: formData.email,
  //     user_name: formData.yourname,
  //     to_name: contactConfig.YOUR_EMAIL,
  //     message: formData.message,
  //   };

  //   emailjs
  //     .send(
  //       // contactConfig.YOUR_SERVICE_ID,
  //       contactConfig.service_2nfxsl1,
  //       // contactConfig.YOUR_TEMPLATE_ID,
  //       contactConfig.template_tndxvcm,
  //       templateParams,
  //       // contactConfig.YOUR_USER_ID
  //       contactConfig.user_PW6Nw1MgGaa55_Rbm
  //     )
  //     .then(
  //       (result) => {
  //         console.log(result.text);
  //         setFormdata({
  //           loading: false,
  //           alertmessage: "SUCCESS! Thank you for your message",
  //           variant: "success",
  //           show: true,
  //         });
  //       },
  //       (error) => {
  //         console.log(error.text);
  //         setFormdata({
  //           alertmessage: `Failed to send! ${error.text}`,
  //           variant: "danger",
  //           show: true,
  //         });
  //         document.getElementsByClassName("co_alert")[0].scrollIntoView();
  //       }
  //     );
  // };
  const form = e.target;
  const templateParams = {
    name: form.name?.value || "",
    weddingDate: form.weddingDate?.value || "",
    venue: form.venue?.value || "",
    planners: form.planners?.value || "",
    instagram: form.instagram?.value || "",
    about: form.sthAboutUs?.value || "",
    user_email: form.email?.value || "",
    user_phone: form.phone?.value || "",
    to_email: "hello@madeinheaven.ca",
  };

  send(
    'service_qsovz0o', // Service ID
    'template_cb5l9km', // Template ID
    templateParams,
    'BBWkyBOwGrb1e524B' // Public Key
  )
  .then((response) => {
    console.log('SUCCESS!', response.status, response.text);
    setFormdata({
      loading: false,
      alertmessage: "SUCCESS! Thank you for your message",
      variant: "success",
      show: true,
    });
    form.reset();
  })
  .catch((err) => {
    console.log('FAILED...', err);
    setFormdata({
      loading: false,
      alertmessage: `Failed to send! ${err.text}`,
      variant: "danger",
      show: true,
    });
  });
};

  const { handleChange, handleBlur, errors, touched, values, handleSubmit: formikSubmit, resetForm } = useFormik({
    initialValues: {
      name: "",
      email: "",
      phone: "",
      weddingDate: "",
      venue: "",
      planners: "",
      photographer: "",
      instagram: "",
      sthAboutUs: "",
    },
    validationSchema: contactUsSchema,
    onSubmit: async (values) => {},
  });

  const dateInputRef = useRef(null);

  const handleFocus = () => {
    dateInputRef.current?.showPicker(); // For browsers that support it
  };
  return (
    <HelmetProvider>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{meta.title} | Contact</title>
        <meta name="description" content={meta.description} />
      </Helmet>
      <div style={{ position: "relative" }}>
        <img
          src={fadeURl}
          className="contactImage"
          alt="Overlay image"
          data-aos="fade-up"
          style={{
            height: "50%",
            position: "relative",
            width: "100%",
            zIndex: "-1",
            top: "-90px",
            opacity: imageOpacity,
            transition: "opacity 0.5s ease",
          }}
        />
      </div>
      <div className="contacttext" data-aos="fade-down">
        <div
          className="container"
          style={{ textTransform: "uppercase", textAlign: "left" }}
        >
          <h3 className="contactHeading" style={{}}>
            HAVE WE MET BEFORE?
          </h3>
          <p className="contactSubHeading" style={{}}>
            BECAUSE YOU LOOK EXACTLY LIKE OUR NEXT COUPLE
          </p>
        </div>
      </div>

      <div className="About-header" style={{ marginBottom: "-5px" }}>
        <Row className=" d-flex justify-content-center  mt-5 pt-5">
          <Col lg="12">
            <Alert
              variant={formData.variant}
              className={`rounded-0 co_alert ${
                formData.show ? "d-block" : "d-none"
              }`}
              onClose={() => setFormdata({ show: false })}
              dismissible
            >
              <p className="my-0">{formData.alertmessage}</p>
            </Alert>
          </Col>

          <div lg="9" className="contactFarm d-flex align-items-center">
            <form onSubmit={handleSubmit} className="contact__form w-100">
              <Row className="d-flex contact-inner">
                <Col lg="12" className="form-group">
                  <label>My Fiance & I</label>
                  <input
                    className="form-control rounded-0"
                    id="name"
                    name="name"
                    placeholder="Audrey Hepburn & Frank Sinata"
                    type="text"
                    onBlur={handleBlur}
                    onChange={handleChange}
                  />
                </Col>

                <Col lg="12" className="form-group">
                  <label>Are getting married on the</label>
                  <input
                    required
                    className="form-control rounded-0"
                    name="weddingDate"
                    type="date"
                    ref={dateInputRef}
                    onFocus={handleFocus}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                </Col>
                <Col lg="12" className="form-group">
                  <label>At</label>
                  <input
                    required
                    className="form-control rounded-0"
                    id="venue"
                    name="venue"
                    placeholder="Qubec City, CA"
                    type="text"
                    onBlur={handleBlur}
                    onChange={handleChange}
                  />
                </Col>
                <Col lg="12" className="form-group">
                  <label>Planned By</label>
                  <input
                    required
                    className="form-control rounded-0"
                    id="planners"
                    name="planners"
                    placeholder="Wedding is planned by XYZ"
                    type="text"
                    onBlur={handleBlur}
                    onChange={handleChange}
                  />
                </Col>
                <Col lg="12" className="form-group">
                  <label>And my Instagram handle is</label>
                  <input
                    required
                    className="form-control rounded-0"
                    id="instagram"
                    name="instagram"
                    placeholder="@audreharbper"
                    type="text"
                    onBlur={handleBlur}
                    onChange={handleChange}
                  />
                </Col>
                <Col lg="12" className="form-group">
                  <label>Here is little bit about our plans</label>
                  <textarea
                    required
                    className="form-control rounded-0"
                    id="sthAboutUs"
                    name="sthAboutUs"
                    type="text"
                    onBlur={handleBlur}
                    onChange={handleChange}
                  />
                </Col>
                <Col lg="12" className="form-group">
                  <label>Email Address </label>
                  <input
                    required
                    className="form-control rounded-0"
                    id="email"
                    name="email"
                    placeholder="audrey@example.com"
                    type="email"
                    onBlur={handleBlur}
                    onChange={handleChange}
                  />
                  {touched.email && errors.email && (
                    <div className="text-danger small mt-1">{errors.email}</div>
                  )}
                </Col>

                <Col lg="12" className="form-group">
                  <label>Phone Number </label>
                  <input
                    required
                    className="form-control rounded-0"
                    id="phone"
                    name="phone"
                    placeholder="+91 (555) 123-4567"
                    type="tel"
                    onBlur={handleBlur}
                    onChange={handleChange}
                  />
                  {touched.phone && errors.phone && (
                    <div className="text-danger">{errors.phone}</div>
                  )}
                </Col>
                <Col lg="12" className="form-group">
                  <button className="submitButton" type="submit">
                    {formData.loading ? "Sending..." : "Send"}
                  </button>
                </Col>
              </Row>
            </form>
          </div>
        </Row>
      </div>

      <div
        style={{
          marginBottom: "20px",
          marginTop: "20px",
          pointerEvents: "none",
          position: "relative",
        }}
      >
        <video
          src={contactVideo}
          autoPlay
          loop
          muted
          className="vid"
          playsInline
          controlsList="nodownload nofullscreen noremoteplayback"
          disablePictureInPicture
          style={{
            // height:"30%",
            padding: "20px",
            width: "100%",
            borderRadius: "50px",
            // position: "absolute",
            objectFit: "cover",
            // zIndex: "-1",
            // top: 0,
            pointerEvents: "none", // Extra protection against interaction
            userSelect: "none", // Prevent text selection
            WebkitTouchCallout: "none",
          }}
        ></video>
      </div>

      <div className="hello" style={{ marginBottom: "40px" }}>
        <h2 className="HelloHeading">Want to say hello?</h2>
        <p className="HelloDesc">
          {" "}
          Send us an email:{" "}
          <a href="mailto:hello@madeinheaven.ca">hello@madeinheaven.ca</a>{" "}
        </p>
      </div>
      <Footer />
      <div className={formData.loading ? "loading-bar" : "d-none"}></div>
    </HelmetProvider>
  );
};
